/**
 * The link one person sends another to become friends.
 *
 * It carries the sender's account id (a Supabase user id, a UUID) and, for the
 * confirmation screen, their name. The id only lets someone ask to be a friend:
 * it grants nothing, and the other side has to accept.
 */

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/i

/** Whether `text` is exactly a user id. */
export function isUserId(text: string): boolean {
  return new RegExp(`^${UUID.source}$`).test(text)
}

/** The link a friend opens to add you. */
export function addFriendLink(userId: string, name: string, origin: string): string {
  const query = name ? `?n=${encodeURIComponent(name)}` : ''
  return `${origin}/add/${userId}${query}`
}

/** A user id from a pasted link or a bare id, if there is one in `input`. */
export function userIdFromInput(input: string): string | null {
  const match = UUID.exec(input.trim())
  return match ? match[0].toLowerCase() : null
}
